import dynamic from 'next/dynamic'

const WhatsappButton = dynamic(() => import('@bluheadless/ui/src/organisms/whatsapp/button'), { ssr: false })
const ZendeskButton = dynamic(() => import('@bluheadless/ui/src/organisms/zendesk/button'), { ssr: false })
const AmazonConnectChatButton = dynamic(() => import('@bluheadless/ui/src/organisms/amazon-connect-chat/button'), {
	ssr: false,
})
const AmazonConnectChatCustomButton = dynamic(
	() => import('@bluheadless/ui/src/organisms/amazon-connect-chat-custom/button'),
	{
		ssr: false,
	}
)

// use same action name as in storeConfig to read enabled config
const actionComponents = {
	whatsapp: WhatsappButton,
	zendesk: ZendeskButton,
	amazonConnectChat: AmazonConnectChatButton,
	amazonConnectChatCustom: AmazonConnectChatCustomButton,
}

export default actionComponents
